import Link from "next/link";
import { usePathname } from "next/navigation";

interface CustomLinkProps {
    href: string;
    title: string;
    className?: string;
    toggle?: any;
}

export const CustomFooterLink = ({href, title, className=''}: CustomLinkProps) => {

    const path = usePathname()
    return (
        <div>
            <Link href={href} className={`${className} uppercase relative group hover:text-hover ${path === href ? 'text-hover' : 'text-white'}`}>
                {title}
                <span className={`h-[1px] inline-block absolute left-0 -bottom-0.5 group-hover:w-full group-hover:bg-hover text-hover transition-[width] ease duration-300 ${path === href ? 'w-full bg-primaryLight dark:bg-primaryDark' : 'w-0'}` }>
                    &nbsp;
                </span>
            </Link>
        </div>
    )
}